import React from "react";
import { Icon, IconProps } from "@iconify/react";

const IconifyIcon = ({ icon, ...rest }: IconProps) => {
  return <Icon icon={icon} fontSize="1rem" {...rest} />;
};

export default IconifyIcon;
